import React from 'react'
import axios from 'axios'

import { SERVER_URL } from 'RLX/Config'
import { getQueryParams, setQueryParam, getAssetAttributes, getIconForAsset, assetsViewLayoutTypes, transformAssetList } from './assets-utils'

export class AssetController extends React.Component {
    constructor (props) {
        super(props)

        const qParams = getQueryParams();
        const layoutParam = qParams.get('layout');
        const pathParam = qParams.get('path');
        const filterQueryParam = qParams.get('filterQuery');

        this.state = {
            dataLoaded: false,
            assets: [],
            selection: [],
            uploadTypes: [],
            filterQuery: filterQueryParam || '',
            layout: layoutParam ? parseInt(layoutParam) : assetsViewLayoutTypes.TILE,
            activeDirectory: pathParam || '/assets/uploads'
        };

        this.componentDidMount = this.componentDidMount.bind(this);
        this.refresh = this.refresh.bind(this);
        this.selectDirectory = this.selectDirectory.bind(this);
        this.checkIfUriExists = this.checkIfUriExists.bind(this);
        this.goToParentDirectory = this.goToParentDirectory.bind(this);
        this.createNewDirectory = this.createNewDirectory.bind(this);
        this.onDirectoryDelete = this.onDirectoryDelete.bind(this);
        this.onDirectoryRename = this.onDirectoryRename.bind(this);
        this.onFileRename = this.onFileRename.bind(this);
        this.onFileDelete = this.onFileDelete.bind(this);
        this.onFileInputChange = this.onFileInputChange.bind(this);
        this.onFilterQueryChange = this.onFilterQueryChange.bind(this);
        this.getFilteredAssets = this.getFilteredAssets.bind(this);
        this.getBreadcrumbs = this.getBreadcrumbs.bind(this);
        this.selectLayout = this.selectLayout.bind(this);
    }

    componentDidMount () {
        this.refresh();
    }

    refresh () {
        this.setState({ ...this.state, dataLoaded: false })

        axios.get(SERVER_URL.concat('/assets'))
            .then((res) => (
                this.setState({
                    dataLoaded: true,
                    uploadTypes: res.headers['x-accept-upload-types'].split(','),
                    assets: transformAssetList(res.data.data)
                })
            ))
    }

    selectDirectory (dir) {
        this.setState({
            ...this.state,
            selection: [],
            activeDirectory: dir
        }, () => {
            setQueryParam('path', dir);
        })
    }

    checkIfUriExists (uri) {
        const { assets } = this.state;

        return assets.some(asset => asset.uri === uri)
    }

    goToParentDirectory () {
        if (this.state.activeDirectory === '/assets') {
            return;
        }

        const pathParts = this.state.activeDirectory.split('/')
        const newDir = pathParts.slice(0, pathParts.length - 1).join('/')

        this.setState({ ...this.state, activeDirectory: newDir });
    }

    createNewDirectory () {
        const newDirName = prompt(`Please enter a name for the new folder within ${this.state.activeDirectory}:\n\n(Please use letters, numbers, hyphens, and/or underscores)`)

        if (!newDirName) {
            return;
        }

        if (!/^[a-zA-Z0-9\-_]+$/.test(newDirName)) {
            alert('Sorry, asset folder names can only consist of letters, numbers, hyphens, and underscores');

            return this.createNewDirectory();
        }

        const fullDirectory = this.state.activeDirectory.concat('/', newDirName);

        if (this.checkIfUriExists(fullDirectory)) {
            return alert('A folder with the name you entered already exists.');
        }

        axios.put(SERVER_URL.concat('/assets', `?${new URLSearchParams({ dirPath: fullDirectory })}`))
            .then(() => {
                {/* alert(`Folder created!`) */}
                this.refresh();
            }, (err) => {
                alert('Error creating new folder ' + (err.message ? '(' + err.message + ')' : ''))
            })

    }

    onDirectoryDelete (uri) {
        const { assets } = this.state;
        const dirName = uri.split('/').pop();
        const children = assets.filter(a => a.parentDir.includes(uri))
        const confirmationText = `Are you sure you want to delete ${!children.length ? `the empty folder /${dirName}?` : `/${dirName}?  It contains ${children.length} item${children.length === 1 ? '' : 's'}.`}`

        if (confirm(confirmationText)) {
            axios.delete(SERVER_URL.concat('/assets', `?${new URLSearchParams({ uri })}`))
                .then(() => {
                    this.refresh();
                }, (err) => {
                    alert(`Error deleting ${uri}: ${err.message ? '(' + err.message + ')' : ''}`)
                })
        }
    }

    onFileRename (uri) {
        const uriParts = uri.split('/')
        const filename = uriParts.pop()
        const replacement = prompt(`Please enter a new filename for "${filename}". \nNote: all references to the old filename will be broken.`, filename);
        const replacementUri = uriParts.concat(replacement).join('/')

        if (!replacement || replacementUri === uri) {
            return;
        }

        if (this.checkIfUriExists(replacementUri)) {
            return alert('Sorry, a file already exists here with that name. Please delete that file and try again if you wish to replace it.');
        }

        axios.put(SERVER_URL.concat('/assets', `?${new URLSearchParams({ fromUri: uri, toUri: replacementUri })}`))
            .then(() => {
                this.refresh();
            }, (err) => {
                alert(`Error renaming ${uri}: ${err.message ? '(' + err.message + ')' : ''}`)
            })
    }

    onDirectoryRename (uri) {
        const uriParts = uri.split('/')
        const filename = uriParts.pop()
        const replacement = prompt(`Please enter a new directory name for "${filename}". \nNote: all references to old paths inside will be broken.`, filename);
        const replacementUri = uriParts.concat(replacement).join('/')

        if (!replacement || replacementUri === uri) {
            return;
        }

        if (this.checkIfUriExists(replacementUri)) {
            return alert('Sorry, a folder already exists here with that name.');
        }

        axios.put(SERVER_URL.concat('/assets', `?${new URLSearchParams({ fromUri: uri, toUri: replacementUri })}`))
            .then(() => {
                this.refresh();
            }, (err) => {
                alert(`Error renaming ${uri}: ${err.message ? '(' + err.message + ')' : ''}`)
            })
    }

    onFileDelete (uri) {
        if (confirm(`Are you sure you want to delete ${uri}?`)) {
            axios.delete(SERVER_URL.concat('/assets', `?${new URLSearchParams({ uri })}`))
                .then(() => {
                    this.refresh();
                }, (err) => {
                    alert(`Error deleting ${uri}: ${err.message ? '(' + err.message + ')' : ''}`)
                })
        }
    }

    onFileInputChange (event) {
      const { files } = event.target;
      const formData = new FormData();
      const filesArray = Array.from(files);

      filesArray.forEach((f, index) => {
        formData.append('upload', files[index]);
      });

      const queryParams = new URLSearchParams({ dir: this.state.activeDirectory })
      const endpoint = SERVER_URL.concat('/assets', `?${queryParams}`)

      const newUris = filesArray.map(file => `${this.state.activeDirectory}/${file.name}`)
      const overwrittenUris = newUris.filter(uri => this.checkIfUriExists(uri))

      if (overwrittenUris.length && !confirm(`The following files will be overwritten by your upload, do you want to continue? \n${overwrittenUris.join(', ')}`)) {
          return;
      }

      console.info('calling ofic', { event, formData, files });

      axios.post(endpoint, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          withCredentials: true,
      }).then((res) => {
          console.log('Upload Success!!', res);
          alert(`Uploaded ${filesArray.length > 1 ? filesArray.length + ' files' : files[0].name}`);
          this.refresh();

          if (this.onAfterUpload) {
              this.onAfterUpload(newUris)
          }
      }, err => {
          console.error('Upload FAIL', err)
          alert('Sorry, there was an error uploading your file. ' + (err && err.message ? err.message : ''));
      })
    }

    onFilterQueryChange(newFilterQuery) {
        this.setState({ ...this.state, filterQuery: newFilterQuery });

        setQueryParam('filterQuery', newFilterQuery)
    }

    getFilteredAssets () {
        return this.state.assets
            .filter(asset => asset.parentDir === this.state.activeDirectory)
            .filter(asset => asset.uri.toLowerCase().includes(this.state.filterQuery.toLowerCase()))
            .sort((a, b) => a.type === 'directory' ? -1 : 1)
    }

    getBreadcrumbs() {
        const pathParts = this.state.activeDirectory.split('/')

        return pathParts.map((name, index) => {
            const path = pathParts.slice(0, index + 1).join('/')
            return { name, path }
        }).filter(p => p.name)
    }

    selectLayout(layout) {
        this.setState({ ...this.state, layout })

        const queryParams = (new URLSearchParams(window.location.search));

        setQueryParam('layout', layout);
    }

}



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Panes/Assets/AssetController.jsx